import { EligibilityStatusEditForm } from 'application/eligibility-status/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { EligibilityStatusService } from 'application/eligibility-status/services';
import { action } from 'mobx';

@applicationContext
class EligibilityStatusEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new EligibilityStatusService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'eligibility-status-edit',
            id: id,
            Form: EligibilityStatusEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: EligibilityStatusEditForm,
        });
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Eligibility Status already exists.' : err.data.message : `Error occurred while trying to update a Eligibility Status.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Eligibility Status already exists.' : err.data.message : `Error occurred while trying to update a Eligibility Status.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('ELIGIBILITY_STATUS.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('ELIGIBILITY_STATUS.EDIT.SUCCESS_UPDATE', name);
    }
}

export default EligibilityStatusEditViewStore;
